/**
 * Validate fields for not being empty
 *
 * @param {string} input - the value of the field being validated
 * @return {boolean} isValid - does the input value pass the test
 */
function lengthValidator(input) {
  const isValid = input.length > 0;

  return isValid;
}

export default lengthValidator;



// WEBPACK FOOTER //
// ./scripts/util/validation/lengthValidator.js